module.exports = __webpack_public_path__ + "static/img/pc-01.2e31619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h2/pc-01.jpg
// module id = t4x5
// module chunks = 1